// Import: Packages
import React from 'react';
import { Div } from '../../../../grid';

const RenderDescription = ({
  productTypePack,
  description,
}) => {
  if (productTypePack) {
    return null;
  }
  return (
    <React.Fragment>
      {description && (
        <Div paddingTop="10px">{description()}</Div>
      )}
    </React.Fragment>
  );
};

// Export Default
export default RenderDescription;
